<modal-header-default class="custom-border"></modal-header-default>
@if (optInViewModel$ | async; as vm) {
  <div class="bp-modal-body-section body custom-padding">
    <div class="general">
      <div class="title">
        {{ "cash_plus_opt_in_title" | translate }}
      </div>
      <div class="description">
        @if (vm.isCashPlusSingleSymbol) {
          <div>
            {{ "cash_plus_opt_in_sentence_one_singular" | translate: [vm.singularSymbol] }}
          </div>
        } @else {
          {{
          "cash_plus_opt_in_sentence_one_plural" | translate: [vm.firstsSymbol, vm.lastSymbol]
          }}
        }
      </div>
      @if (isDynamictermAndConditionActive$ | async) {
        <!-- dynamic -->
        <div class="text-left">
          @if (bundles) {
            <terms-and-conditions-updates [bundles]="bundles"></terms-and-conditions-updates>
          }
        </div>
      } @else {
        @if (vm.isLimitOrdersEnabled) {
          <bp-switch
            [model]="optInTermsSlider"
            field="limit_orders"
            [mb]="30"
            [css]="'custom-toggle-position'">
            <div left class="slider-general">
              <div class="slider-description">
                {{ "cash_plus_opt_in_limit_orders" | translate }}
              </div>
            </div>
          </bp-switch>
        }
        @if (vm.isCardActive) {
          <bp-switch
            [model]="optInTermsSlider"
            field="card_terms"
            [mb]="30"
            [css]="'custom-toggle-position'">
            <div left class="slider-general">
              <div class="slider-description">
                {{ "cash_plus_opt_in_card_description" | translate }}
              </div>
            </div>
          </bp-switch>
        }
        <bp-switch [model]="optInTermsSlider" field="terms_and_conditions" [mb]="30" [css]="'custom-toggle-position'">
          <div left class="slider-general">
            <div class="slider-description">
              {{ "cash_plus_opt_in_sentence_two" | translate }}
              <a [href]="link" target="_blank">{{ "cash_plus_derivative_contract" | translate }}</a
                ><span>{{ ", " }}</span>
                <span>{{ "cash_plus_opt_in_sentence_three" | translate }}</span>
                <a [href]="link" target="_blank">{{ "cash_plus_key_information" | translate }}</a
                  ><span>{{ ", " }}</span>
                  <a [href]="link" target="_blank">{{ "cash_plus_prospectus" | translate }}</a
                    ><span>{{ ", " }}</span>
                    <a [href]="link" target="_blank">{{ "cash_plus_investor_information" | translate }}</a
                      ><span>{{ "cash_plus_and" | translate }}</span>
                      <a [href]="link" target="_blank">{{ "cash_plus_cost_transparency_documents" | translate }}</a
                        >@if (!isGerman) {
                        <span>{{ "." }}</span>
                      }
                      @if (isGerman) {
                        <span>{{ "cash_plus_opt_in_german" | translate }}</span>
                      }
                    </div>
                  </div>
                </bp-switch>
                @if (vm.isUserNotAppropriate) {
                  <bp-switch
                    [model]="optInTermsSlider"
                    field="non_appropriate_user"
                    [mb]="30"
                    [css]="'custom-toggle-position'">
                    <div left class="slider-general">
                      <div class="slider-description non-appropriate">
                        {{ "stocks_toggle_not_appropriate_title" | translate }}
                      </div>
                      <div class="slider-description">
                        {{ "stocks_toggle_not_appropriate_description" | translate }}
                      </div>
                    </div>
                  </bp-switch>
                }
              }
            </div>
            @if (vm.isLoading) {
              <div>
                <button class="btn btn-primary button disabled">
                  <loading-spinner class="no-padding spinner-padding"></loading-spinner>
                </button>
              </div>
            } @else {
              <button
                class="btn btn-primary button"
			[ngClass]="{
				disabled: isButtonDisabled(vm)
			}"
                (click)="onButtonClick(vm.isCardActive, vm.isUserNotAppropriate, vm.isLimitOrdersEnabled)">
                {{ "cash_plus_opt_in_button" | translate }}
              </button>
            }
          </div>
        }
        <div class="custom-footer-container">
          {{ "stocks_powered_by" | translate }}
        </div>
